import React from "react"
//import components
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { useTranslation } from "react-i18next"

import CategoriesTable from "./CategoriesTable"

export default function CategoriesList() {
  const { t } = useTranslation()

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs title="" breadcrumbItem={t("pages.Categories")} />
        <CategoriesTable />
      </div>
    </div>
  )
}
